module.exports = __webpack_public_path__ + "img/loading-circles.b8a11ddf.gif";